'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024 from "./presto.types$-Two-Factor-Auth-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$Tables$$anon$10() {
}
export { $c_Lpresto_TwoFactorAuthView$Tables$$anon$10 as $c_Lpresto_TwoFactorAuthView$Tables$$anon$10 };
$p = $c_Lpresto_TwoFactorAuthView$Tables$$anon$10.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$Tables$$anon$10;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$Tables$$anon$10() {
}
export { $h_Lpresto_TwoFactorAuthView$Tables$$anon$10 as $h_Lpresto_TwoFactorAuthView$Tables$$anon$10 };
$h_Lpresto_TwoFactorAuthView$Tables$$anon$10.prototype = $p;
$p.aR = (function(item) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a, item.e2.kZ, $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024.$m_Lpresto_types$TwoFactorAuthName$().a2K());
});
var $d_Lpresto_TwoFactorAuthView$Tables$$anon$10 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$Tables$$anon$10, "presto.TwoFactorAuthView$Tables$$anon$10", ({
  TO: 1,
  A: 1
}));
export { $d_Lpresto_TwoFactorAuthView$Tables$$anon$10 as $d_Lpresto_TwoFactorAuthView$Tables$$anon$10 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Tables$$anon$10.js.map
